export const formatDistanceLocal = (meters) => {
  const miles = meters / 1609.34;
  if (miles < 0.1) {
    return "nearby";
  } else if (miles < 10) {
    return `${miles.toFixed(1)} mi away`;
  } else {
    return `${Math.round(miles)} mi away`;
  }
};

export const formatPickupLocation = (location) => {
  if (!location) return 'Pickup location not available';
  const city = location.city || '';
  const postalCode = location.postalCode || '';
  if (city && postalCode) {
    return `${city}, ${postalCode}`;
  } else if (city) {
    return city;
  } else if (postalCode) {
    return postalCode;
  }
  return 'Pickup location not available';
};

export const getAvailableDates = () => {
  const dates = [];
  const today = new Date();
  for (let i = 1; i <= 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push(date);
  }
  return dates;
}; 